import LeftActive from "assets/leftActive.svg";
import Right from "assets/right.svg";
import { useEffect, useState } from "react";
import ImageGallery from "react-image-gallery";
import Box from "ReusableComponents/Box";
import { SIZES } from "theme";
import "./Hero.css";
import HeroOverlay from "./HeroOverlay";

const Hero = ({
  isHiload,
  hiloadBannerText,
  hiloadSlider,
  launchSider,
  homeSliders,
  imageSliders,
  small,
  medium,
}) => {
  const [main, setMain] = useState(
    isHiload
      ? hiloadSlider[0]?.attributes?.title
      : homeSliders[0]?.attributes?.title
  );
  const [subtitle, setSubtitle] = useState(
    isHiload
      ? hiloadSlider[0]?.attributes?.subtitle
      : homeSliders[0]?.attributes?.subtitle
  );

  const [desc, setDesc] = useState(
    isHiload
      ? hiloadSlider[0]?.attributes?.description
      : homeSliders[0]?.attributes?.description
  );
  const [index, setIndex] = useState(0);

  const [images, setImages] = useState([]);
  const [isLaunchSlider, setIsLaunchSlider] = useState(true);
  const [isLaunchCompleted, setIsLaunchCompleted] = useState(false);

  function updateLaunchCompleted(value) {
    setIsLaunchCompleted(value);
  }

  useEffect(() => {
    let sliderData = imageSliders
      ? imageSliders
      : isHiload
      ? hiloadSlider
      : homeSliders;

    // setMain(launchSider?.attributes?.title);
    // setSubtitle(launchSider.attributes?.subtitle);
    // setDesc(launchSider?.attributes?.description);

    let sliderImages = sliderData?.map((item) => ({
      original: !small
        ? item.attributes?.banner?.data?.attributes?.url
        : item.attributes?.banner_mobile?.data?.attributes?.url,
      originalAlt: item.attributes?.banner?.data?.attributes?.alternativeText,
      loading: "eager",
    }));

    // sliderImages = sliderData?.map((item) => ({
    //   original: !small
    //     ? item.attributes?.banner_img?.data?.attributes?.url
    //     : item.attributes?.media_mobile?.data?.attributes?.url,
    //   originalAlt:
    //     item.attributes?.banner_img?.data?.attributes?.alternativeText,
    //   loading: "eager",
    // }));

    // sliderImages.unshift({
    //   original: isLaunchCompleted
    //     ? small
    //       ? launchSider?.attributes?.post_image_mobile?.data?.attributes?.url
    //       : launchSider?.attributes?.post_image?.data?.attributes?.url
    //     : small
    //     ? launchSider?.attributes?.pre_image_mobile?.data?.attributes?.url
    //     : launchSider?.attributes?.pre_image?.data?.attributes?.url,
    //   originalAlt: isLaunchCompleted
    //     ? small
    //       ? launchSider?.attributes?.post_image_mobile?.data?.attributes
    //       : launchSider?.attributes?.post_image?.data?.attributes
    //     : small
    //     ? launchSider?.attributes?.pre_image_mobile?.data?.attributes
    //         ?.alternativeText
    //     : launchSider?.attributes?.pre_image?.data?.attributes?.alternativeText,
    //   loading: "eager",
    // });

    setImages(sliderImages);
  }, [
    isHiload,
    hiloadSlider,
    homeSliders,
    launchSider,
    isLaunchCompleted,
    imageSliders,
  ]);

  return (
    <Box position="relative">
      {/* {isHiload && isLaunchSlider && !isLaunchCompleted ? (
        <HiloadHeroOverlay
          updateLaunchCompleted={updateLaunchCompleted}
          hiloadBannerText={hiloadBannerText}
          main={main}
          desc={desc}
          subtitle={subtitle}
          launchSlider={launchSider}
          index={index}
          small={small}
          medium={medium}
        />
      ) : isLaunchSlider && !isLaunchCompleted ? (
        <HeroOverlay
          updateLaunchCompleted={updateLaunchCompleted}
          main={main}
          index={index}
          desc={desc}
          launchSlider={launchSider}
          subtitle={subtitle}
          small={small}
          medium={medium}
          imageSliders={imageSliders}
        />
      ) : (
        <HeroOverlay
          main={main}
          index={index}
          desc={desc}
          isBooking
          subtitle={subtitle}
          small={small}
          medium={medium}
          imageSliders={imageSliders}
        />
      )} */}
      <HeroOverlay
        main={main}
        index={index}
        desc={desc}
        isBooking
        subtitle={subtitle}
        small={small}
        medium={medium}
        imageSliders={imageSliders}
        slideDuration={2000}

      />

      <ImageGallery
        style={{ maxHeight: 772 }}
        showFullscreenButton={false}
        lazyLoad={true}
        items={images}
        autoPlay={true}
        slideDuration={2000}
        showPlayButton={false}
        onSlide={(s) => {
          setIndex(s);

          if (s === 0) {
            // setIsLaunchSlider(true);
            // setMain(launchSider?.attributes?.title);
            // setSubtitle(launchSider.attributes?.subtitle);
            // setDesc(launchSider?.attributes?.description);
          } else {
            // setIsLaunchSlider(false);
            s = s - 1;
            // if (!isHiload) {
            //   setMain(homeSliders[s]?.attributes?.title);
            //   setSubtitle(homeSliders[s]?.attributes?.subtitle);
            //   setDesc(homeSliders[s]?.attributes?.description);
            // } else {
            //   setMain(hiloadSlider[s]?.attributes?.title);
            //   setSubtitle(hiloadSlider[s]?.attributes?.subtitle);
            //   setDesc(hiloadSlider[s]?.attributes?.description);
            // }
          }
        }}
        renderLeftNav={(onClick) => (
          <Box
            borderRadius={"50%"}
            h="50px"
            w="50px"
            onClick={onClick}
            cursor={"pointer"}
            position="absolute"
            zIndex="2"
            bottom={small ? "0px" : "60px"}
            right={small ? "60px" : "120px"}
          >
            <img
              src={LeftActive}
              alt="left"
              style={{ height: small && "32px" }}
            />
          </Box>
        )}
        renderRightNav={(onClick) => (
          <Box
            borderRadius={"50%"}
            h="50px"
            w="50px"
            onClick={onClick}
            cursor={"pointer"}
            position="absolute"
            right={small ? "8px" : SIZES.forty}
            zIndex="2"
            bottom={small ? "0px" : "60px"}
          >
            <img src={Right} alt="right" style={{ height: small && "32px" }} />
          </Box>
        )}
      />
    </Box>
  );
};

export default Hero;
